import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { Typography } from "@mui/material";
import { formateDate } from "../../utils/timeHelper";
// import { getNotifications } from "../../http/auth";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    border: "1px solid rgb(55, 65, 81, 0.1)",
    padding: "10px 10px 5px 10px",
    marginTop: theme.spacing(1),
    minWidth: 180,
    maxWidth: "80%",
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px -3px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      maxHeight: "440px",
      overflowY: "auto",
      padding: "0 4px",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function NotificationsMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [list, setList] = React.useState([]);

  const open = Boolean(anchorEl);

  React.useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    try {
      const res = await getNotifications();
      if (res.data.data?.notifications) setList(res.data.data.notifications);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        sx={{
          background: "transparent",
          boxShadow: "none",
          "&:hover": { background: "transparent" },
          justifyContent: "flex-end",
          width: "fit-content",
          padding: "0",
        }}
      >
        <NotificationsNoneOutlinedIcon
          sx={{ cursor: "pointer", color: "#0832DE" }}
        />
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Typography sx={{ marginBottom: "12px" }}>Notifications: </Typography>
        {list?.map((item) => (
          <MenuItem
            disableRipple
            sx={{
              flexDirection: "column",
              alignItems: "flex-start",
              border: "1px solid rgb(55, 65, 81, 0.2)",
              marginBottom: "10px",
              cursor: "default",
              borderRadius: "10px",
              padding: "6px 10px !important",
            }}
          >
            <Typography sx={{ whiteSpace: 'break-spaces' }}>
              {item.body}
            </Typography>
            <Typography sx={{ marginLeft: "auto", opacity: 0.7 }}>
              {formateDate(new Date(item.createdAt), "DD-MM-YYYY, hh:mm a")}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
